// stylelint-disable declaration-no-important
// stylelint-disable no-descending-specificity
@import '../../style/index';

@include host {
  margin-top: var(--spacings-xl);

  rcm-column:first-child {
    @include large-up() {
      padding-right: var(--spacings-xl) !important;
    }
  }

  rcm-column:last-child {
    @include large-up() {
      padding-left: var(--spacings-xl) !important;
    }
  }

  .reverse {
    flex-direction: row-reverse;

    rcm-column:first-child {
      @include large-up() {
        padding-left: var(--spacings-xl) !important;
        padding-right: var(--columnGap) !important;
      }
    }

    rcm-column:last-child {
      @include large-up() {
        padding-right: var(--spacings-xl) !important;
        padding-left: var(--columnGap) !important;
      }
    }
  }

  .author {
    display: block;
    margin-top: rem-calc(16px);
    font-size: rem-calc(16px);
    color: var(--colors-dark-base);
  }

  p {
    @include copy-primary();

    margin: 0;
  }

  .content {
    padding-top: 0.5rem;
  }
}
